import { render } from "./MasterPage.vue?vue&type=template&id=e8aa261c&scoped=true"
import script from "./MasterPage.vue?vue&type=script&lang=js"
export * from "./MasterPage.vue?vue&type=script&lang=js"

import "./MasterPage.vue?vue&type=style&index=0&id=e8aa261c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3141391227/src/github.com/DeepAngle/DDR-Atlas-Proto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8aa261c"]])

export default __exports__